import { TypeDefinition } from "../generic";

interface Type extends TypeDefinition {
    code: string;
}

export class FDRelationshipTypes {
    public static A: Type = { id: 1, code: "A", name: "Advisory Board" };
    public static B: Type = { id: 2, code: "B", name: "Board of Directors" };
    public static C: Type = { id: 3, code: "C", name: "Consultant" };
    public static EM: Type = { id: 4, code: "EM", name: "Employee" };
    public static F: Type = { id: 5, code: "F", name: "Founder" };
    public static I: Type = { id: 6, code: "I", name: "Investigator" };
    public static SP: Type = { id: 7, code: "SP", name: "Speaker" };
    public static SH: Type = { id: 8, code: "SH", name: "Stockholder" };
    public static O: Type = { id: 9, code: "O", name: "Other" };

    public static Values: Type[] = [
        FDRelationshipTypes.A,
        FDRelationshipTypes.B,
        FDRelationshipTypes.C,
        FDRelationshipTypes.EM,
        FDRelationshipTypes.F,
        FDRelationshipTypes.I,
        FDRelationshipTypes.SP,
        FDRelationshipTypes.SH,
        FDRelationshipTypes.O,
    ];
}



// WEBPACK FOOTER //
// ./src/models/financialDisclosure/FDRelationshipTypes.ts